export default __webpack_public_path__ + "static/decathlonProLogoMobile-0c0bb22c60e7df6d2b178fc608846725.svg";